import { Theme, makeStyles } from '@material-ui/core/styles'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { TemporalNow } from 'src/commons/temporalHelpers'
import InformationBanner from 'src/components/InformationBanner'

interface IWarnProp {
  toDate?: Temporal.ZonedDateTime
}

export default function WarnBanner(props: IWarnProp) {
  const classes = useStyles()
  const { t } = useTranslation()
  return (
    <InformationBanner
      showBanner={props.toDate ? props.toDate.epochMilliseconds >= TemporalNow().epochMilliseconds : false}
      message={t('kpi.warning.incomplete_data')}
      className={classes.informationBanner}
    />
  )
}

function useStyles() {
  return makeStyles((theme: Theme) => ({
    root: {
      flex: 1,
      display: 'flex',
    },
    content: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'center',
      width: '100%',
      paddingLeft: theme.spacing(48),
    },
    card: {
      minWidth: '50%',
      maxWidth: '95%',
      width: '100%',
      backgroundColor: '#f3f5f7',
    },
    informationBanner: {
      margin: theme.spacing(1),
      marginBottom: theme.spacing(1), // to respect padding
    },
  }))()
}
